module.exports = __webpack_public_path__ + "img/a.5c25c94c.png";